module.exports = __webpack_public_path__ + "static/dog-training-trick-plank-827161b994e5f10e8d0de5f728a55a9b.jpg";